import { createContext } from "react";

const InventoryTransactionContext = createContext();

const InventoryTransactionProvider = ({ children }) => {

  return (
    <InventoryTransactionContext.Provider
      value={{

      }}
    >
      {children}
    </InventoryTransactionContext.Provider>
  );
};


export { InventoryTransactionContext, InventoryTransactionProvider };